// The four disciplines: their pages (routes, titles, descriptions) and panel copy.
module.exports = [
  {
    key: 'experiential',
    path: '/experiential',
    name: 'Experiential Marketing',
    title: 'Experiential Marketing Agency London | IGNIS',
    copy: 'Placing brands at the heart of the conversation, creating experiences that drive engagement and social reach.',
    description: 'Ignis London is an experiential marketing agency. We place brands at the heart of the conversation with brand events, festival activations, sampling and live experiences that drive engagement and social reach.',
  },
  {
    key: 'shopper',
    path: '/shopper-marketing',
    name: 'Shopper Marketing',
    title: 'Shopper Marketing Agency London | IGNIS',
    copy: 'Managing Shopper hesitation to convert brand in mind to brand in hand at point of purchase.',
    description: 'Ignis London is a shopper marketing agency. We manage shopper hesitation with in-store and retail activation that converts brand in mind to brand in hand at the point of purchase.',
  },
  {
    key: 'social',
    path: '/social-digital',
    name: 'Social & Digital',
    title: 'Social & Digital Marketing Agency London | IGNIS',
    copy: 'Building scale for brands with hard to reach audiences, creating campaigns that intersect with culture.',
    description: 'Ignis London is a social and digital marketing agency. We build scale for brands with hard to reach audiences through social content, campaigns and digital experiences that intersect with culture.',
  },
  {
    key: 'comms',
    path: '/corporate-communications',
    name: 'Corporate Communications',
    title: 'Corporate Communications Agency London | IGNIS',
    copy: 'Empowering and engaging employees and stakeholders throughout large organisations.',
    description: 'Ignis London is a corporate communications agency. We empower and engage employees and stakeholders throughout large organisations with internal and corporate events and communications.',
  },
];
